import styled from '@emotion/styled'

export const Background = styled.div`
    width: 100%;
    position: relative;
    z-index: 0;
    background-color: ${(props) => props.theme.primaryColor.white[2]};
    margin-bottom: 77.6px;
    @media (max-width: ${(props) => props.theme.breakPoints.miniTablet}) {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        padding-bottom: 0px;
    }
    @media (max-width: ${(props) => props.theme.breakPoints.phone}) {
        padding-bottom: 0px;
    }
`

export const TestimonialContainer = styled.div`
    width: 100%;
    max-width: ${(props) => props.theme.containerWidth};
    position: relative;
    z-index: 2;
    margin: 0 auto 0 auto;
    display: flex;
    justify-content: flex-end;

    @media (max-width: ${(props) => props.theme.breakPoints.phone}) {
        justify-content: center;
    }
`

export const ImageWrapper = styled.img`
    position: absolute;
    top: 0;
    left: 0;
    width: 50%;
    height: 463px;
    object-fit: cover;
    z-index: 1;

    @media (max-width: ${(props) => props.theme.breakPoints.miniTablet}) {
        position: static;
        align-self: flex-end;
        width: 100%;
    }
`

export const Card = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 736px;
    margin-top: 64px;
    // padding: 32px;
    gap: 16px;
    background-color: ${(props) => props.theme.primaryColor.white[2]};
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2);
    z-index: 2;

    h3 {
        font-family: Yantramanav-Bold;
        font-size: 48px;
        letter-spacing: -3px;
        margin: unset;

        color: ${(props) => props.theme.primaryColor.blue[3]};
    }

    h4 {
        font-family: Inter-Light;
        font-size: 18px;
        color: ${(props) => props.theme.primaryColor.grey[3]};
        margin: unset;
        font-weight: 200;
    }

    @media (max-width: ${(props) => props.theme.breakPoints.phone}) {
        width: 100%;
        word-wrap: break-word;

        h3 {
            font-size: 40px;
            letter-spacing: -2px;
        }

        h4 {
            font-size: 14px;
        }
    }
`
